import React from 'react'
import { connect } from 'react-redux'
import './seachPage.scss'
import SearchBox from './components/searchBox'
import TranslationResult from './components/translationsList'
import { RouteComponentProps } from 'react-router';
import queryString from 'query-string'
import { BingTranslatorClient, TranslationResult as BingTranslationResult } from '../../api/bingTranslatorApi';
import config from '../../Config'
import { push } from 'connected-react-router'

interface RouteParams {
    query: string
}

interface SearchPageProps extends RouteComponentProps<RouteParams> {
    push(url: string) : void
}

interface SearchPageState {
    translationResult?: BingTranslationResult
}

class SearchPage extends React.Component<SearchPageProps, SearchPageState> {
    private translator: BingTranslatorClient;

    constructor(props: SearchPageProps) {
        super(props);
        this.translator = BingTranslatorClient.create(config.bingSettings);
        this.state = {};
        this.searchTranslation = this.searchTranslation.bind(this);
    }

    async componentDidMount() {
        await this.loadResults();
    }

    async loadResults() {
        let currentQuery = this.getSearchQuery();
        if (currentQuery) {
            let result = await this.translator.getTranslations(currentQuery);
            this.setState({translationResult: result});
        }
    }

    async componentDidUpdate(){
        let translationResult = this.state.translationResult && this.state.translationResult.displaySource;

        if (this.getSearchQuery() !== translationResult) {
            await this.loadResults();
        }
    }

    getSearchQuery(props: SearchPageProps = this.props) {
        let queryStringArgs = queryString.parse(props.location.search);
        return queryStringArgs['q'] as string;
    }

    async searchTranslation(request: string) {
        console.log('starting searchTranslation');
        this.props.push(`/search?${queryString.stringify({q: request})}`);
        console.log('ending searchTranslation');
    }

    render() {
        const renderTranslationResult = () => {

            if (this.state.translationResult) {
                if (this.state.translationResult.translations.length > 0) {
                    return <TranslationResult translationResult={this.state.translationResult} />;
                } else {
                    return <h2>No results found. Have you made a typo?</h2>;
                }
            }
            else {
                return <h2>Try to search something above...</h2>;
            }
        } 

        return (
            <div>
                <SearchBox value={this.getSearchQuery() || ''} startSearch={this.searchTranslation} />
                {renderTranslationResult()}
            </div>
        );
    }
}



export default connect(null, { push })(SearchPage);